<template>
  <div class="button-div">
    <div class="div-chexbox-button">
      <ListMenuWithCheckbox
        v-if="showZoneMenu.value || showZoneMenuHover"
        :title="title"
        :categories="categories"
        @onChecklistToggle="updateFilteredLayersPlanview"
        @onHoverListMenu="$emit('onHoverListMenu')"
        @closeHoverListMenu="$emit('closeHoverListMenu')"
      />
      <ButtonSquareHoverChecklist
        :title="$t('general__data__area-zones')"
        :imgSource="iconLayers"
        size="large"
        style="padding-top: 24px"
        :activeState="activeState"
        @clicked="toggleVisible()"
        @hovered="$emit('PlanViewFilterButtonHovered')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import ListMenuWithCheckbox from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import iconLayers from '@/assets/icons-general/icon-layers.svg'
import { SET_SHOW_ZONE_MENU } from '@/store/mutation-types'

// Props and emits
const props = defineProps<{
  categories: Array<any>
  showZoneMenuHover: boolean
  title: string
}>()
const emit = defineEmits([
  'mouseleave',
  'PlanViewFilterButtonHovered',
  'onChecklistToggle',
  'onHoverListMenu',
  'closeHoverListMenu',
  'clicked'
])

// Vuex store
const store = useStore()

// State
const showZoneMenu = computed(() => store.state.showZoneMenu)
const active = ref(false)

// Compute active state for the button
const activeState = computed(() => {
  if (!props.categories.length) {
    return 'deactivated'
  }
  if (showZoneMenu.value) {
    return 'active'
  } else {
    return 'inactive'
  }
})

// Toggle visibility of zone menu
function toggleVisible() {
  if (activeState.value === 'deactivated') return
  active.value = !showZoneMenu.value
  emit('clicked', active.value)
  setShowZoneMenu(active.value)
}

// Checklist toggle handler
function updateFilteredLayersPlanview(typeId: string, categoryId: string, checked: boolean) {
  emit('onChecklistToggle', typeId, categoryId, checked)
}

// Mutation
function setShowZoneMenu(value: boolean) {
  store.commit(SET_SHOW_ZONE_MENU, value)
}

// Action
function hideHoverButtons() {
  active.value = false
  setShowZoneMenu(active.value)
}

defineExpose({
  hideHoverButtons
})
</script>

<style lang="scss" scoped>
.button-div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.div-chexbox-button {
  display: flex;
  justify-content: center;
}
</style>
